export class Motoboy {
    id?: string;
    dominio?: string;
    nome?: string;
    ativo?: boolean;
    status?: string;
    token?: string;
    telefone?: string;
    			

}
